import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import WhoWeAre from "./pages/WhoWeAre";
import WhatWeDo from "./pages/WhatWeDo";
import Programs from "./pages/Programs";
import StrategicAdvisory from "./pages/StrategicAdvisory";
import OrgChange from "./pages/OrgChange";
import Founder from "./pages/Founder";
import LeadershipToolkit from "./pages/LeadershipToolkit";
import LeadersAgenda from "./pages/LeadersAgenda";
import EnlightenedLeadership from "./pages/EnlightenedLeadership";
import CLevelCoaching from "./pages/CLevelCoaching";
import Contact from "./pages/Contact";
import Series1 from "./pages/Series1";
import Series2 from "./pages/Series2";
import Series3 from "./pages/Series3";


export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/who-we-are" element={<WhoWeAre />} />
        <Route path="/what-we-do" element={<WhatWeDo />} />
        <Route path="/programs" element={<Programs />} />
        <Route path="/strategic-advisory" element={<StrategicAdvisory />} />
        <Route path="/org-change" element={<OrgChange />} />
        <Route path="/founder" element={<Founder />} />
        <Route path="/leadership-toolkit" element={<LeadershipToolkit />} />
        <Route path="/leaders-agenda" element={<LeadersAgenda />} />
        <Route path="/enlightened-leadership" element={<EnlightenedLeadership />} />
        <Route path="/c-level-coaching" element={<CLevelCoaching />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/series-1" element={<Series1 />} />
        <Route path="/series-2" element={<Series2 />} />
        <Route path="/series-3" element={<Series3 />} />

      </Routes>
    </Router>
  );
}
